import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Alert, Skeleton } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styles from './summary_item.module.scss';
import { useMainStore } from '../../pages/main/main_store';
import { DataTypeKeys, SectionKeys } from '../../../constant/index';
import { SectionIcon } from '../section_icon/section_icon';
import { useSessionStore } from '../../../context/session';
import { ApiError, ApiResponse } from '../../../api/api';
import { SectionCountReponse } from '../../../model/section_response';
import { Messages } from '../../../constant/messages';

/**
 * 特記事項のプロパティ
 */
interface SummaryItemProps {
  // 作業区分コード
  sectionCode: SectionKeys;
  // 作業区分名
  sectionName: string;
}

/**
 * 特記事項
 * @param sectionCode
 * @param sectionName
 * @constructor
 */
export const SummaryItem: React.FC<SummaryItemProps> = ({ sectionCode, sectionName }) => {
  const { getSectionCount } = useMainStore((selector) => selector);
  const { selectedDivisionId, selectedFloorId } = useSessionStore((selector) => selector);

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState<'timeout' | 'error' | undefined>(undefined);
  const [count, setCount] = useState(0);

  const navigator = useNavigate();

  useEffect(() => {
    // 特記事項取得
    setIsLoading(true);
    setIsError(undefined);
    getSectionCount(selectedDivisionId, sectionCode, dayjs())
      .then(
        (response: ApiResponse) => {
          if (response.isError) {
            setIsError('error');
          } else {
            const res = response.data as SectionCountReponse;
            setCount(res.count);
          }
        },
      )
      .catch((e) => {
        if (e instanceof ApiError) {
          if (e.response.status === -1) {
            setIsError('timeout');
          }
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [selectedDivisionId]);


  const onClick = () => {
    if (sectionCode === SectionKeys.bispot) {
      navigator(`/schedule?type=${DataTypeKeys.dataTypeBispot}&division=${selectedDivisionId}&floor=0`);
      return;
    }
    navigator(`/schedule?sections=${sectionCode}&type=${DataTypeKeys.dataTypeBispot}&division=${selectedDivisionId}&floor=0`);
  };

  // 状態によってレイアウト変更
  if (isLoading) {
    // API実行中
    return (
      <div
        style={{ minWidth: '15%', display: 'block', height: '57px', margin: '10px' }}
        data-active={true}
        data-testid='summary_item_loading'
      >
        <Skeleton.Button active={true} size='large' block={true} style={{ height: '100%' }} />
      </div>
    );
  }
  if (isError === 'timeout') {
    // API実行NG
    return (
        <div
            data-active={true}
            data-testid='summary_item_error'
        >
          <Alert message={Messages.ERR_DIALOG_TIMEOUT} type="error" showIcon />
        </div>
    );
  }
  if (isError === 'error') {
    // API実行NG
    return (
        <div 
          data-active={true}
          data-testid='summary_item_error'
        >
          <Alert message={Messages.ERR_OTHER} type="error" showIcon />
        </div>
    );
  }
  // API実行OK
  return (
    <>
      <div
        className={styles.item}
        onClick={onClick}
        data-active={true}
        data-testid='summary_item'
      >
        <div className={styles.icon}>
          <SectionIcon sectionCode={sectionCode} />
        </div>
        <div className={styles.title}>
          {sectionName}
        </div>
        <div className={styles.number}>
          {count}件
        </div>
        <div className={styles.arrow}>
          <ArrowRightOutlined />
        </div>
      </div>
      </>
  );
};

